/* eslint-disable linebreak-style */
import { defineMessages } from 'react-intl';

export default defineMessages({
  seeMore: {
    id: 'See more',
    defaultMessage: 'See more',
  }
});
